import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "card-header"
};
const _hoisted_2 = {
  class: "header-left"
};
const _hoisted_3 = {
  class: "content-wrapper"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  key: 2,
  class: "video-container"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "video-actions"
};
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { Document, VideoPlay } from "@element-plus/icons-vue";
export default {
  __name: 'MaterialHistory',
  setup(__props, {
    expose: __expose
  }) {
    const {
      t
    } = useI18n();
    const visible = ref(false);
    const list = ref([]);
    const type = ref("");
    const openInNewTab = url => {
      if (url) {
        window.open(url, "_blank");
      }
    };
    const title = computed(() => {
      const map = {
        image: t("orderReview.table.imageStatus"),
        pdf: t("orderReview.table.pdfStatus"),
        video: t("orderReview.table.videoStatus")
      };
      return map[type.value] || t("orderReview.common.historyRecord");
    });
    const open = (dataList, dataType) => {
      if (!dataList) {
        list.value = [];
        return;
      }
      // Ensure we sort by date descending if not already sorted?
      // Or trust the backend. Usually history is best shown latest first.
      // Let's sort just in case: newer createdAt first.
      // Assuming createdAt is string "YYYY-MM-DD HH:mm:ss"
      const sortedList = [...dataList].sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      list.value = sortedList;
      type.value = dataType;
      visible.value = true;
    };

    // eslint-disable-next-line no-undef
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_timeline_item = _resolveComponent("el-timeline-item");
      const _component_el_timeline = _resolveComponent("el-timeline");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => visible.value = $event),
        title: title.value,
        width: "800px",
        "destroy-on-close": "",
        "append-to-body": ""
      }, {
        default: _withCtx(() => [list.value && list.value.length ? (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 0,
          "max-height": "60vh"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_timeline, {
            style: {
              "padding-right": "20px",
              "padding-top": "10px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return _openBlock(), _createBlock(_component_el_timeline_item, {
                key: index,
                timestamp: item.createdAt,
                placement: "top",
                type: item.isLast ? 'success' : '',
                color: item.isLast ? '#0bbd87' : ''
              }, {
                default: _withCtx(() => [_createVNode(_component_el_card, {
                  shadow: "hover"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [item.isLast ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "success",
                    effect: "dark"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("orderReview.common.currentVersion")), 1)]),
                    _: 1
                  })) : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "info"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("orderReview.common.historyRecord")), 1)]),
                    _: 1
                  }))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
                    class: "header-right"
                  }, null, -1))]), _createElementVNode("div", _hoisted_3, [type.value === 'image' ? (_openBlock(), _createBlock(_component_el_image, {
                    key: 0,
                    style: {
                      "width": "100px",
                      "height": "100px",
                      "border-radius": "4px"
                    },
                    src: item.url,
                    "zoom-rate": 1.2,
                    "max-scale": 7,
                    "min-scale": 0.2,
                    "preview-src-list": [item.url],
                    "initial-index": 0,
                    fit: "cover",
                    "preview-teleported": "",
                    "hide-on-click-modal": ""
                  }, null, 8, ["src", "preview-src-list"])) : type.value === 'pdf' ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: item.url,
                    target: "_blank",
                    class: "pdf-link"
                  }, [_createVNode(_component_el_icon, {
                    class: "el-icon--left"
                  }, {
                    default: _withCtx(() => [_createVNode(_unref(Document))]),
                    _: 1
                  }), _createTextVNode(" " + _toDisplayString(_ctx.$t("orderReview.common.viewPDF")), 1)], 8, _hoisted_4)) : type.value === 'video' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("video", {
                    src: item.url,
                    controls: "",
                    class: "video-player"
                  }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
                    type: "primary",
                    link: "",
                    onClick: $event => openInNewTab(item.url)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, {
                      class: "el-icon--left"
                    }, {
                      default: _withCtx(() => [_createVNode(_unref(VideoPlay))]),
                      _: 1
                    }), _createTextVNode(" " + _toDisplayString(_ctx.$t("orderReview.common.openInNewWindow")), 1)]),
                    _: 2
                  }, 1032, ["onClick"])])])) : _createCommentVNode("", true)])]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["timestamp", "type", "color"]);
            }), 128))]),
            _: 1
          })]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: _ctx.$t('common.noData')
        }, null, 8, ["description"]))]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};